import axios from 'axios';
//const address="http://localhost:8000/api/";
const address="http://translationservice.clovermandalay.org/dashboard/api/";
export const postData = async (url,data)  => {
        let response=axios.post(address+url,data);
        return response;
}

